<template>
  <div class="charttest">
    <div   style="width: 100%;
      height: 245px;" :id="echarts" ref="echarts">
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  import { mapActions } from "vuex";

  export default {
    name:'LineChart',
    data() {
      return {
       loading: false,
        myChart1: "",
        rectangular: [
        {
          value: "",
          name: "",
        },
      ],
      };
    },
      created() {
        this.initChartsChart()
      },

    methods: {
         ...mapActions("category", [
        "getChartData",
    ]),

 initChartsChart() {
  let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "pa_ipc_outline",
        },
      };

      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
          _this.chartsdatapicthree = res.message.data.slice(0, 10);
          _this.rectangular = _this.chartsdatapicthree.map((item) => {
            //去掉缩放

            return {
              value: item.num,
              name: item.ipcName.slice(0, 10),
            };
          });
        },
      });

    },


 initChart() {
      this.myChart = echarts.init(this.$refs.echarts);
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },

      drawCharts() {
        var myChart = echarts.init(document.getElementById(this.echarts));
        myChart.setOption({
       title: {
          text: "",
          subtext: "",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}",
        },
        calculable: false,
        color: [
          "#48B3FF",
          "#33D1B1",
          "#94D3FF",
          "#6FE9D0",
          "#B3EBE0",
          "#C4E6FF",
          "#FFC143",
          "#FFCF6D",
          "#FFE1A5",
          "#FFECEC",
        ],
        series: [
          {
            breadcrumb: { show: false }, //去掉底部下面黑色
            name: "",
            barWidth: 1000,
            type: "treemap",
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b}",
                  color: "#000",
                },
                borderWidth: 1,
              },
              emphasis: {
                label: {
                  show: true,
                },
              },
            },
            data: this.rectangular,
          },
        ],
        });
      }
    },
    computed: {
      echarts() {
        return 'echarts' + Math.random() * 100000;
      }
    },
    mounted() {
    //   this.drawCharts();
      this.$nextTick(() => {
      setTimeout(() => {
        this.drawCharts();
      
      },1000);
    });
    },
     destroyed() {
    window.removeEventListener("resize", this.initChart, 20);
  },
    components: {}
  };
</script>

<style></style>